
var io = require('socket.io-client');

import util from '../util/util';

var axios = require('axios');

// SCOPE:
// So that we can talk to the outer iframe if needed.
var _scope = window.top.document;


var updateBroadcasting = function(data){

  _scope.Creek.debug.log(data);

  if(!data){
    data = { now: { title: "", short_name: "" }, next: {}, Track: {} };
  }

  _scope.Creek.API.Broadcasting = data;
  _scope.Creek.audio.live.API.Show = data.now;
  _scope.Creek.audio.live.API.Track = data.Track;

  //Set up data for current show
  _scope.Creek.audio.title = data.now.title || null;

  _scope.Creek.audio.live.content.URL = _scope.Creek.config.content.pathPrefix
    + _scope.Creek.config.content.showsPath 
    + _scope.Creek.API.Broadcasting.now.short_name;

  // _scope.Creek.audio.util.resetSpacerHeight();

  _scope.Creek.config.API.live.callback(data);

}


var initializeLiveAPI = function(){

  //Always use HTTPS for Socket.io
  var socket_url = 'https://live-api.creek.fm/';

  var socket = io(socket_url);

  _scope.Creek.debug.log("Connecting to Live API at: "+socket_url);


  //Handle when the station connects with socket.io
  socket.on('api connection', function(data){

    _scope.Creek.debug.log('Connected to Live API.');

    //Select the station, based on ID supplied in Creek.init({...})
    socket.emit('station select', _scope.Creek.config.station.domain, function(){

      _scope.Creek.debug.log("Selected station: " + _scope.Creek.config.station.domain);

    });

  })

  //Update Creek data and UI when broadcasting data is updated.
  socket.on('api broadcasting', function(data){
    if(_scope.Creek.config.API.live.enable){
      updateBroadcasting(data);
    }
  })

  //Error handling
  socket.on('connect_error', function(err){
    _scope.Creek.debug.log("ERROR: Could not connect: "+err);
    return false;
  })
  socket.on('connect_timeout', function(err){
    _scope.Creek.debug.log("ERROR: Connection timed out: "+err)
    return false;
  })
  socket.on('reconnect_error', function(err){
    _scope.Creek.debug.log("ERROR: Could not reconnect: "+err)
    return false;
  })
  socket.on('reconnect_failed', function(err){
    _scope.Creek.debug.log("ERROR: Too many failed reconnection attempts: "+err)
    return false;
  })


}


const CreekLivePlugin = {

  install(Vue, options) {
    
    initializeLiveAPI();

  }

};

export default CreekLivePlugin;
